export default "/fonts/ReverIcons.svg?e690075b7b5d3fb0175ed1a30e51c3f2";